import React from 'react';
import { PageWrapper } from 'src/components/PageWrapper';
export const wrapPageElement = ({
  element,
  props
}) => {
  const location = props.location;
  if (location.pathname.startsWith('/admin/') || location.pathname.startsWith('/reference')) return element;
  return React.createElement(PageWrapper, null, element);
};